<template>
  <div class="c-childBanner">
    <div class="c-childBanner__text">
      <h2>
        <p @click="$router.push({name: 'product'})">{{$t('menu.product_back')}}</p>
        {{content.title}}
      </h2>
      <p>{{content.content}}</p>
    </div>
    <div class="c-childBanner__img">
      <img :src="content.img" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bannerChild',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
